import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import DealerNav from "./DealerNav";
import InventoryIntelligenceReport, { formatDifference, formatPosition } from "./InventoryIntelligenceReport";

const API = process.env.REACT_APP_API_BASE;
export { formatDifference, formatPosition };

export default function DealerInventoryIntelligence() {
  const navigate = useNavigate();
  const token = useMemo(() => localStorage.getItem("dealerToken") || "", []);
  const [sort, setSort] = useState("difference_desc");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [scope, setScope] = useState("");

  useEffect(() => {
    if (!token) { navigate("/dealer/login", { replace: true }); return; }
    let cancelled = false;
    setLoading(true); setError("");
    const params = new URLSearchParams({ sort });
    if (scope) params.set("scope", scope);
    fetch(`${API}/dealer/inventory/intelligence?${params}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        if (response.status === 401 || response.status === 403) { navigate("/dealer/login", { replace: true }); throw new Error("Unauthorized"); }
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then((payload) => { if (!cancelled) setData(payload); })
      .catch((err) => { if (!cancelled && err.message !== "Unauthorized") setError("Could not load inventory intelligence. Please try again."); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [navigate, scope, sort, token]);

  return <div className="min-h-screen bg-gray-50"><DealerNav /><main className="max-w-7xl mx-auto px-4 pb-10">
    <div className="mb-5">
      {data?.dealerGroupName && <p className="text-lg font-semibold text-blue-800">{data.dealerGroupName}</p>}
      <h1 className="text-2xl font-semibold text-gray-900">Inventory Intelligence</h1>
      <p className="text-sm text-gray-600">What Meshum sees across your active inventory right now.</p>
      {data?.dealerGroupId != null && <label className="mt-4 block max-w-sm text-sm font-medium text-gray-700">Rooftop
        <select aria-label="Inventory Intelligence rooftop" value={scope || data.selectedScope || ""} onChange={(event) => setScope(event.target.value)} className="mt-1 block w-full rounded-lg border border-gray-300 bg-white px-3 py-2">
          <option value="all">All Rooftops</option>
          {(data.availableRooftops ?? []).map((rooftop) => <option key={rooftop.dealerId} value={String(rooftop.dealerId)}>{rooftop.dealerName}</option>)}
        </select>
      </label>}
    </div>
    <InventoryIntelligenceReport data={data} loading={loading} error={error} sort={sort} onSortChange={setSort} showRooftop={data?.dealerGroupId != null} />
  </main></div>;
}
